import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function NotFoundPage(): ReactNode {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold">Pagina no encontrada</h1>
      <p className="text-muted-foreground">
        La direccion que intentas abrir no existe.
      </p>
      <Button asChild>
        <Link to="/dashboard">Volver al panel</Link>
      </Button>
    </div>
  )
}
